import {AxiosError} from 'axios'
import {useEffect, useState} from 'react'
import {listContent} from '../modules/auth/core/_requests'
import {Route, Routes} from 'react-router-dom'
import SelectedContent from '../pages/Management/SelectedContent'
import {Error404Management} from '../modules/errors/components/Error404Management'

function ContentRoutes() {
  const [contentList, setContentList] = useState<any>([])
  const [contentPaths, setContentPaths] = useState<string[]>([])

  const getList = async () => {
    try {
      const {data} = await listContent(0, '', 'en', '')
      setContentList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      setContentList([])
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
  }, [])

  useEffect(() => {
    setContentPaths(generateContentPaths(contentList))
  }, [contentList])

  const generateContentPaths = (data: any) => {
    const paths: any = []

    data.map((item: any) => {
      let id = item.id
      let path = `/${item.id}`
      paths.push({id, path})
    })
    return paths
  }

  if (contentPaths.length === 0) {
    return null
  }

  return (
    <Routes>
      {contentPaths.map((item: any, index: number) => {
        return (
          <Route key={index} path={`${item.path}`} element={<SelectedContent id={item.id} />} />
        )
      })}

      <Route
        path='*'
        element={
          <div className='d-flex justify-content-center align-items-center '>
            <div className='text-center d-flex flex-column align-items-center'>
              <Error404Management />
            </div>
          </div>
        }
      />
    </Routes>
  )
}

export default ContentRoutes
